import React from 'react'
import {ProjectCard} from '../../components/ProjectCard'

const projects = [
  {
    title: 'Clicky Game',
    url: 'https://dwilli77.github.io/clicky-game/',
    github:'https://github.com/dwilli77/clicky-game',
    image: './images/clicky-game.png',
    tech: ['React', 'Materialize'],
    description: "12 flags are displayed on the screen. Click all 12 withouth clicking the same one twice. Be careful, it's not as easy as it sounds!"
  },
  {
    title: "Write Share",
    url: 'https://young-river-62844.herokuapp.com/',
    github: 'https://github.com/dwilli77/write-share1',
    image: './images/write-share.png',
    tech: ['React', 'Node', 'Express', 'MongoDB'],
    description: "A blog-style website for collaborative creative writing. Create an account and join a writing pod. Each member of the pod take turns adding to the story."
  },
  {
    title: "Mortgage Documentation",
    url: "https://dwilli77.github.io/mortgage-documentation/",
    github: 'https://github.com/dwilli77/mortgage-documentation',
    image: './images/mortgage-docs.png',
    tech: ['jQuery', 'jsPDF'],
    description: "Applicaiton for mortgage professionals to determine documentation needed to submit files to underwriting."
  },
  {
    title: "Word Guess",
    url: "https://dwilli77.github.io/word-guess-game/",
    github: 'https://github.com/dwilli77/word-guess-game',
    image: './images/word-guess.png',
    tech: ['Vanilla JavaScript'],
    description: "Select your category and use the keyboard to guess a letter."
  },
  {
    title: "Mortgage Trivia",
    url: "https://dwilli77.github.io/TriviaGame/",
    github: 'https://github.com/dwilli77/TriviaGame',
    image: './images/trivia.png',
    tech: ['jQuery', 'setTimeout/setInterval'],
    description: "A timed trivia game testing your mortgage knowledge."
  },
  {
    title: 'Crystal Collector',
    url: 'https://dwilli77.github.io/unit-4-game/',
    github: 'https://github.com/dwilli77/unit-4-game',
    image: './images/crystal.png',
    tech: ['jQuery', 'Bootstrap'],
    description: "Try to make your score match the target number. Each crystal is assigned a random value. Click the crystal to add to your score. Be careful, the crystals change values every game!"
  }
]

class Portfolio extends React.Component {
  render() {
    return(
      <div className="container" style={{backgroundColor: 'rgba(204,204,204,0.7)'}}>
        <h1 className="center-align red-text text-lighten-2" style={{fontFamily:'Leckerli One'}}>Portfolio</h1>
        <div style={{martinTop:10, paddingBottom: 15}} className="container">
          <div className="row">
          {projects.map(proj => {
            return(
              <div className="col s12 m12 l6">
                <ProjectCard image={proj.image} title={proj.title} url={proj.url} github={proj.github} tech={proj.tech} description={proj.description} />
              </div>
            )
          })}
          </div>
        </div>
      </div>
    )
  }
}

export default Portfolio;